import { useState, useEffect } from 'react';

export const useScrollSpy = () => {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'services', 'showroom', 'about', 'contact'];
      const scrollPosition = window.scrollY + 200; // Offset for header height

      // If we're at the very top, ensure home is active
      if (window.scrollY < 100) {
        setActiveSection('home');
        return;
      }

      // Special case for bottom of page (to highlight contact properly)
      // This ensures contact section remains highlighted when scrolling to the very bottom
      // Check BEFORE normal detection to ensure it takes priority
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );
      
      if (window.innerHeight + window.scrollY >= documentHeight - 100) {
        setActiveSection('contact');
        return;
      }

      // Normal section detection
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    // Set initial active section
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return activeSection;
}; 